import { Tag } from '@scale/scaleui';
import { numberToDollars } from 'react-scale/components/scalers/tasks/OutlierTaskHeader/utils';
import { ProjectOutlineSectionStatus } from 'react-scale/remotasks.com/components/Expert/ProjectOnboarding/components/ProjectOutlineSectionStatus';
import { ProjectOutlineNodeStatus } from 'react-scale/remotasks.com/components/Expert/ProjectOnboarding/types';
import { PayRatePayFunctionType, PayRateType } from '@scale/shared/defaults';

type OutlineSectionTitleAdornmentProps = {
  status: ProjectOutlineNodeStatus;
  payRate?: number | null;
  payRateType?: PayRatePayFunctionType;
};

export const OutlineSectionTitleAdornment = ({
  status,
  payRate,
  payRateType,
}: OutlineSectionTitleAdornmentProps) => {
  const payType = payRateType === PayRateType.PayPerTask ? 'task' : 'hr';
  return (
    <div className="flex items-center gap-1">
      {payRate && (
        <Tag size="sm" variant="success">
          <span className="text-success-700">{`${numberToDollars(payRate)}/${payType}`}</span>
        </Tag>
      )}
      <ProjectOutlineSectionStatus status={status} />
    </div>
  );
};
